import keeperEligibility2026 from '../keeperEligibility2026.json';
import keeperMarket2026 from '../keeperMarket2026.json';
import { applyCurrentKeeperMarket } from '../../utils/keeperMarket';

const MANAGER_SLUGS = {
  'A.J.': 'a-j',
  Amir: 'amir',
  Anna: 'anna',
  Bryan: 'bryan',
  Josh: 'josh',
  Kevin: 'kevin',
  Kyle: 'kyle',
  Robby: 'robby',
  Ryan: 'ryan',
  Samuel: 'samuel',
};

const RISK_RUBRIC = [
  { level: 'Review news', color: 'gold', copy: 'The Aug. 19 market is current, but every candidate receives a final injury and role review on Aug. 25.' },
  { level: 'No-pick value', color: 'gold', copy: 'A player missing from the 2025 draft results may be kept without forfeiting a 2026 draft pick.' },
];

const SCORING_TRANSLATION = [
  { title: 'Two quarterbacks', copy: 'Bruins09 requires two starting quarterbacks, while the ESPN baseline has one QB and one superflex slot. Quarterback scarcity is therefore stronger here.' },
  { title: 'Six-point pass TDs', copy: 'Passing touchdowns score six instead of ESPN’s four-point baseline, increasing the value of stable starting quarterbacks.' },
  { title: 'Full PPR', copy: 'Every reception scores one point, preserving the value of high-volume receivers, backs, and tight ends.' },
  { title: 'Volume bonuses', copy: 'Rushing attempts score 0.33 and 100-yard rushing or receiving games earn bonuses, rewarding durable weekly workloads.' },
];

function positionFor(player, marketPlayer) {
  if (marketPlayer?.position) return marketPlayer.position;
  if (['QB', 'RB', 'WR', 'TE', 'K', 'DEF'].includes(player.finalRosterPosition)) {
    return player.finalRosterPosition;
  }
  return 'FLEX';
}

function buildBaseDossier(managerSource) {
  const slug = MANAGER_SLUGS[managerSource.manager];
  const marketManager = keeperMarket2026.managers.find((manager) => manager.manager === managerSource.manager);
  const marketByPlayer = new Map((marketManager?.players || []).map((player) => [player.player, player]));

  return {
    meta: {
      slug,
      manager: managerSource.manager,
      yahooTeamName: managerSource.yahooTeamName,
      yahooTeamId: Number(managerSource.yahooTeamId),
      status: 'current',
      asOfLabel: 'Aug 19, 2026',
      nextRefreshLabel: 'Aug 25, 2026',
      draftLabel: 'Sat Aug 29, 2026',
      keeperDeadlineLabel: 'Wed Aug 26, 2026',
      isDemo: false,
      rosterSourceCaptured: true,
      waiverCostConfirmed: true,
      tradedReceiptTrackingEnabled: true,
      finalVerdictPublished: false,
    },
    riskRubric: RISK_RUBRIC,
    scoringTranslation: SCORING_TRANSLATION,
    candidates: managerSource.players.map((player) => {
      const marketPlayer = marketByPlayer.get(player.player);
      return {
        player: player.player,
        position: positionFor(player, marketPlayer),
        team: marketPlayer?.nflTeam || 'Verify',
        cost: player.keeperCostRound ? `Round ${player.keeperCostRound}` : 'No pick',
        market: 'Loading Aug. 19 market',
        surplus: 'n/a',
        grade: 'Pending',
        risk: 'Review news',
        note: player.draftedIn2025
          ? `Authenticated Yahoo final-roster player, originally drafted in Round ${player.keeperCostRound}.`
          : 'Authenticated Yahoo final-roster player absent from the 2025 draft results; no 2026 draft pick is forfeited if kept.',
      };
    }),
  };
}

export const KEEPER_DOSSIERS = Object.fromEntries(
  keeperEligibility2026.managers.map((manager) => [
    MANAGER_SLUGS[manager.manager],
    applyCurrentKeeperMarket(buildBaseDossier(manager), keeperMarket2026),
  ]),
);

export function getKeeperDossier(slug) {
  if (!slug) return null;
  return KEEPER_DOSSIERS[String(slug).toLowerCase()] || null;
}

export function listAvailableDossierSlugs() {
  return Object.keys(KEEPER_DOSSIERS);
}
